import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import {
  ProjectionKind,
  usePerformancePendingReviewersDataTable,
} from 'generated/resources/datatable.graphql'
import { PerformancePendingReviewersStatDocument } from 'generated/resources/graphql'

import DataTable from 'modules/core/components/DataTable'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { InlineEmployee } from 'modules/employees/components/InlineEmployee'

const PendingReviewersDataTable = ({ reviewId }: { reviewId: number }) => {
  const { data, loading } = useQuery(PerformancePendingReviewersStatDocument, {
    variables: { id: reviewId },
  })

  const pendingReviewersIds = data?.performance.reviewProcessStat?.pendingReviewersIds ?? []

  const source = usePerformancePendingReviewersDataTable(
    [
      {
        identifier: 'target',
        title: i18n.t('performance_process.reviews.peer_management.peers_datatable.employee'),
        fixed: true,
        kind: ProjectionKind.Custom,
        template: '{{ employee_access_fullName }}',
        colSpan: 2,
        render: ({ employee }) => {
          return employee && <InlineEmployee employee={employee} />
        },
      },
      {
        identifier: 'manager',
        title: i18n.t('performance_process.reviews.peer_management.peers_datatable.manager'),
        fixed: true,
        kind: ProjectionKind.Custom,
        template: '{{ employee_manager_access_fullName }}',
        colSpan: 2,
        render: ({ employee }) => {
          return employee?.manager ? <InlineEmployee employee={employee.manager} hideAvatar /> : '-'
        },
      },
    ],
    {
      variables: { ids: pendingReviewersIds },
      defaultSort: 'firstName',
    }
  )

  if (loading) return <Skeleton isLoading height="full" />

  return (
    <DataTable.Provider
      source={source}
      pagination={{
        kind: 'cursor',
        itemsPerPage: 50,
      }}
    >
      <Box gap="s16" overflowY="hidden">
        <DataTable.HeadBar
          exportFileName={i18n.t('performance_process.overview.participation.export_filename')}
        />
        <DataTable.Table />
      </Box>
    </DataTable.Provider>
  )
}

export default PendingReviewersDataTable
